<form #form [formGroup]="formGroup" (ngSubmit)="submitForm()">
  <span class="form-header mb-4" i18n>What is the nature of the member’s submission?</span>
  <div class="submission-type-container">
    <div class="radio-container">
      <app-radio-button-input
        formControlName="submissionType"
        [controlId]="'rebalance'"
        [value]="ChangeInvestmentInstructionSubmissionTypeEnum.Rebalance"
        [name]="'submissionType'" />
      <div class="radio-text-container">
        <app-form-option-label [labelFor]="'rebalance'" i18n>Rebalance Accumulated Funds</app-form-option-label>
        <span class="radio-subtext" i18n>
          Update how the existing balance is allocated among the investment funds.
        </span>
      </div>
    </div>
    <div class="radio-container">
      <app-radio-button-input
        formControlName="submissionType"
        [controlId]="'adjust'"
        [value]="ChangeInvestmentInstructionSubmissionTypeEnum.AdjustFutureContributions"
        [name]="'submissionType'" />
      <div class="radio-text-container">
        <app-form-option-label [labelFor]="'adjust'" i18n>Adjust Future Contributions</app-form-option-label>
        <span class="radio-subtext" i18n>
          Update how the upcoming contributions will be distributed among the funds.
        </span>
      </div>
    </div>
  </div>
  <div *ngIf="formGroup.controls.submissionType.invalid && formSubmitted" class="error mt-3" i18n>
    A selection is required to continue
  </div>
  <hr />
  <span class="form-header mb-3" i18n>Which account(s) does this submission apply to?</span>
  <p i18n>
    Note that applying different investment instructions to individual accounts will limit the member’s ability to make
    changes on their own in the future.
  </p>
  <p i18n>
    When multiple accounts are selected, the same investment instructions and/or fund allocation changes will be applied
    to all selected.
  </p>
  <div class="d-flex flex-column gap-4" *ngIf="!(isLoading$ | async); else loading">
    <!-- Defined Contribution Accounts -->
    <app-investment-instruction-account-type-container
      *ngIf="(dcAccountFormArray$ | async)?.controls?.length"
      [form]="formGroup"
      [formSubmitted]="formSubmitted"
      [accounts]="dcAccountFormArray$ | async"
      [accountsHidden]="dcAccountsHidden$ | async"
      [accountTypeId]="AccountTypeIdEnum.DefinedContribution"
      radioControlId="definedContribution" />

    <!-- Variable Benefit Accounts -->
    <app-investment-instruction-account-type-container
      *ngIf="(vbAccountFormArray$ | async)?.controls?.length"
      [form]="formGroup"
      [formSubmitted]="formSubmitted"
      [accounts]="vbAccountFormArray$ | async"
      [accountsHidden]="vbAccountsHidden$ | async"
      [accountTypeId]="AccountTypeIdEnum.VariableBenefit"
      radioControlId="variableBenefit" />

    <!-- TODO: Placeholder account type, make dynamic when possible. -->
    <div class="account-type-container">
      <div class="radio-container">
        <app-radio-button-input
          formControlName="accountType"
          [controlId]="'retirement'"
          [value]="AccountTypeIdEnum.Retirement"
          [name]="'accountType'" />
        <app-form-option-label [labelFor]="'retirement'" i18n>Retirement Accounts</app-form-option-label>
      </div>
    </div>
  </div>

  <div *ngIf="formGroup.controls.accountType.invalid && formSubmitted" class="error mt-3" i18n>
    A selection is required to continue
  </div>
</form>

<ng-template #loading>
  <div class="account-type-container">
    <lib-loading-shimmer [width]="'100%'" [height]="'13rem'" />
  </div>
  <div class="account-type-container">
    <lib-loading-shimmer [width]="'100%'" [height]="'13rem'" />
  </div>
</ng-template>
